module.exports = __webpack_public_path__ + "static/media/imagemIE.e96491e7.png";